<template>
  <section>
    <!-- Notification for mobile display -->
    <div v-if="newInbox" class="d-block d-sm-none">
      <router-link to="/inbox">
        <div class="row section-notification">
          <div class="col-12 text-center">
            <i class="fas fa-envelope"></i>
            {{ $t('message.home.you_got_new_message') }}
            <svg class="notification-alert">
              <circle cx="3" cy="3" r="3"/>
            </svg>
          </div>
        </div>
      </router-link>
    </div>
    <!-- Section Hero New -->
    <section class="section-hero" :class="{'p-4' : $mq.phone}">
      <div class="row">
        <div class="col-md-8 col-12 hero-content">
          <div class="hero-title">{{ $t('message.hero.title') }}</div>
          <div class="hero-sub-title">{{ $t('message.hero.sub_title') }}</div>
          <div class="hero-action-button mt-2">
            <template v-if="user">
              <router-link to="/cleaners" tag="button"
                           class="button-large -cyan mr-2 mt-1"
                           v-if="hasCompletedOrders">
                <img class="mr-2" src="/static/img/hero/book_my_cleaner.png" width="24">{{ $t('message.hero.book_my_cleaner') }}
              </router-link>
              <router-link to="/booking/start"
                           tag="button"
                           class="button-large mr-2 mt-1"
                           :class="[hasCompletedOrders ? 'button-outline-white' : '-cyan']">
                <img class="mr-2" src="/static/img/hero/find_new_cleaner.png" width="24" v-if="hasCompletedOrders"><img class="mr-2" src="/static/img/hero/action_button.png" width="24" v-else>{{ $t('message.hero.find_new_cleaner') }}
              </router-link>
              <a href="https://line.me/R/ti/p/%40hnk7011n" class="button-large -line-green mt-1">
                &nbsp;<img class="mr-2" src="/static/img/hero/chat.png" width="24">{{ $t('message.hero.chat') }}&nbsp;
              </a>
            </template>
            <template v-else>
              <div>
                <router-link to="/booking/start" tag="a" class="button-large -cyan mr-2 mt-1 mb-0">
                  &nbsp;<img class="mr-2" src="/static/img/hero/action_button.png" width="24">{{ $t('message.hero.action_button') }}&nbsp;
                </router-link>
                <a href="https://line.me/R/ti/p/%40hnk7011n" class="button-large -line-green mt-1 mb-0">
                  &nbsp;<img class="mr-2" src="/static/img/hero/chat.png" width="24">{{ $t('message.hero.chat') }}&nbsp;
                </a>
              </div>
              <div class="hero-login-text mt-3">
                {{ $t('message.hero.or') }}&nbsp;
                <a href="#" @click.prevent="openLoginModal">{{ $t('message.hero.login_beneat') }}</a>
              </div>
            </template>
          </div>
          <div class="text-left d-none d-sm-block mt-4">
            <ul class="hero-list list-unstyled">
              <li>
                <i class="fas fa-check text-primary"></i>&nbsp;&nbsp;{{ $t('message.hero.feature01') }}
              </li>
              <li>
                <i class="fas fa-check text-primary"></i>&nbsp;&nbsp;{{ $t('message.hero.feature02') }}
              </li>
              <li>
                <i class="fas fa-check text-primary"></i>&nbsp;&nbsp;{{ $t('message.hero.feature03') }}
              </li>
              <li>
                <i class="fas fa-check text-primary"></i>&nbsp;&nbsp;{{ $t('message.hero.feature04') }}
              </li>
            </ul>
          </div>
          <div class="hero-download-app">
            <p>{{ $t('message.hero.download_app') }}</p>
            <a href="https://itunes.apple.com/th/app/beneat/id1203611695?mt=8" target="_blank">
              <img height="36" alt="BeNeat iOS App" src="/static/img/btn-app-store.svg">
            </a>&nbsp;
            <a href="https://play.google.com/store/apps/details?id=com.beneat.app" target="_blank">
              <img height="36" alt="BeNeat Android App" src="/static/img/btn-play-store.svg">
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- User Coins and Points -->
    <user-coins-points/>

    <!-- Promotion Slider -->
    <promotion-slider/>

    <!-- New menu -->
    <section class="mt-2">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <router-link to="/booking/new" tag="a" class="no-style">
            <div class="card shadow-sm">
              <div class="card-body p-0 d-flex">
                <div class="menu-icon text-center -menu">
                  <img src="/static/img/ic-select-cleaner.svg" alt="" width="50">
                </div>
                <div class="justify-content-center align-self-center mx-3">
                  <h3 class="menu-title">{{ $t('message.menu.search_professionals') }}</h3>
                  <div>{{ $t('message.menu.search_professionals_detail') }}</div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </router-link>
        </div>

        <div class="col-12 col-md-6 col-lg-4">
          <router-link to="/special-services/search?service_id=7" tag="a" class="no-style">
            <div class="card shadow-sm">
              <div class="card-body p-0 d-flex">
                <div class="menu-icon text-center -accepted">
                  <img src="/static/img/ic-select-therapist.svg" alt="" width="50">
                </div>
                <div class="justify-content-center align-self-center mx-3">
                  <h3 class="menu-title">{{ $t('message.menu.search_therapists') }}</h3>
                  <div>{{ $t('message.menu.search_therapists_detail') }}</div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>

    <!-- Section Our Services -->
    <section class="section-padding-home section-services">
      <div class="row">
        <div class="col-12">
          <h3 class="home-title">{{ $t('message.home.popular_services') }}</h3>
        </div>
      </div>
      <div class="row mt-2">
        <template v-for="(service, index) in sortedServices">
          <div class="col-lg-3 col-4 pb-3 text-center" 
               :class="{'pb-3' : $mq.phone}" 
               v-if="service.parent_id === 0 && service.service_type === 'popular' && service.is_hidden === 0">
            <router-link :to="service.route_url" tag="a" class="no-style">
              <div class="card">
                <div class="card-image">
                  <img :src="service.picture" alt="">
                </div>
              </div>
              {{ service | multiLangName  }}
            </router-link>
          </div>
        </template>
      </div><!-- /.row -->

      <!-- Section Subscription Services -->
      <div class="row mt-3">
        <div class="col-12">
          <h3 class="home-title">{{ $t('message.home.subscription_service') }}</h3>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-lg-3 col-6 text-center"
             :class="{'pb-3' : $mq.phone}"
             v-for="subscriptionService, index in globalState.subscriptionServices">
          <router-link to="/booking/start?subscriptionTypeId=1" tag="a" class="no-style" v-if="index === 0">
            <div class="card">
              <div class="card-image">
                <img v-lazy="subscriptionService.picture" alt="">
              </div>
            </div>
            {{ subscriptionService | multiLangName }}
          </router-link>
        </div>
      </div>

      <!-- Section Specialty cleaning -->
      <div class="row mt-3 d-flex justify-content-start align-items-center">
        <div class="col-6">
          <h3 class="home-title mb-0">{{ $t('message.home.specialty_services') }}</h3>
        </div>
        <div class="col-6 text-right">
          <router-link to="/special-services/search" class="text-primary-link">
            {{ $t('message.home.view_specialty_services') }} <i class="far fa-angle-right"></i>
          </router-link>
        </div>
      </div>

      <div class="row mt-2">
        <template v-for="service, index in sortedServices">
          <div class="col-lg-3 col-4 pb-3 text-center" 
               :class="{'pb-3' : $mq.phone}" 
               v-if="service.parent_id === 0 && service.service_type === 'special' && service.is_hidden === 0">
            <router-link :to="getServiceUrl(service)" tag="a" class="no-style">
              <div class="card">
                <div class="card-image">
                  <img :src="service.picture" alt="">
                </div>
              </div>
              {{ service | multiLangName }}
            </router-link>
          </div>
        </template>

        <!-- <div class="col-lg-3 col-6" :class="{'pb-3' : $mq.phone}">
          <router-link to="/beneat-for-host" tag="a" class="no-style">
            <div class="card"
                 :class="{'h-100' : $mq.phone}">
              <div class="card-image">
                <img src="/static/img/beneat-for-host.png" alt="">
              </div>
              <div class="card-body">
                <div class="text-center">
                  <div class="service-title">{{ $t('message.home.service09') }}</div>
                </div>
              </div>
            </div>
          </router-link>
        </div> -->
        <!-- /.col-md-4 -->
      </div>

      <!-- Section Reviews -->
      <section>
        <review-by-user/>
      </section>

      <div class="row mt-4">
        <div class="col-12">
          <!-- <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank"> -->
          <a href="https://line.me/R/ti/p/@BeNeat" target="_blank">
            <img src="/static/img/beneat-package.png" alt="" class="img-fluid rounded d-none d-sm-block">
            <img src="/static/img/beneat-package-sm.jpg" alt="" class="img-fluid rounded d-block d-sm-none">
          </a>
        </div>
      </div>
    </section>

    <recommend-professionals :provinceId="1"/>

    <recommend-professionals :provinceId="2"/>

    <!-- Section Why Choose Us ? -->
    <hr>
    <section class="section-padding-home section-solution">
      <h2 class="text-center">{{ $t('message.home.solution_title') }}</h2>
      <div class="row">
        <div class="col-12 text-lg-center text-sm-left">
          <p>{{ $t('message.home.solution_detail') }}</p>
        </div>
      </div>
      <div class="row mt-lg-4 mt-2">
        <div class="col-lg-4 col-12 text-center">
          <img src="/static/img/cleaning-equipment.svg" width="60">
          <h3 class="mt-3">{{ $t('message.home.solution_title01') }}</h3>
          <p>{{ $t('message.home.solution_detail01') }}</p>
        </div>
        <div class="col-lg-4 col-12 text-center">
          <img src="/static/img/select-user.svg" width="60">
          <h3 class="mt-3">{{ $t('message.home.solution_title02') }}</h3>
          <p>{{ $t('message.home.solution_detail02') }}</p>
        </div>
        <div class="col-lg-4 col-12 text-center">
          <img src="/static/img/protect.svg" width="60">
          <h3 class="mt-3">{{ $t('message.home.solution_title03') }}</h3>
          <p>{{ $t('message.home.solution_detail03') }}</p>
          <p class="text-remark">{{ $t('message.home.solution_detail03_remark') }}</p>
        </div>
      </div>
    </section>

    <!-- Section Cleaner -->
    <section class="section-cleaner section-padding-gray">
      <div class="row">
        <div class="col-md-6">
          &nbsp;&nbsp;
        </div>
        <div class="col-md-6">
          <h2>{{ $t('message.home.who_is_your_cleaner') }}</h2>
          <p>{{ $t('message.home.who_is_your_cleaner_detail') }}</p>
          <div class="mt-4">
            <router-link class="text-primary-link" to="/about-the-cleaners">
              <h3>{{ $t('message.home.learn_more') }}</h3>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Section How it works -->
    <section class="section-padding">
      <h2 class="text-center">{{ $t('message.home.how_it_works') }}</h2>
      <div class="row mt-4">
        <div class="col-lg-4 col-12 text-center">
          <img src="/static/img/calendar-time.svg" width="60">
          <h3 class="mt-3">{{ $t('message.home.how_it_works_title01') }}</h3>
          <p>{{ $t('message.home.how_it_works_detail01') }}</p>
        </div>
        <div class="col-lg-4 col-12 text-center">
          <img src="/static/img/confirm.svg" width="60">
          <h3 class="mt-3">{{ $t('message.home.how_it_works_title02') }}</h3>
          <p>{{ $t('message.home.how_it_works_detail02') }}</p>
        </div>
        <div class="col-lg-4 col-12 text-center">
          <img src="/static/img/cleaner.svg" width="60">
          <h3 class="mt-3">{{ $t('message.home.how_it_works_title03') }}</h3>
          <p>{{ $t('message.home.how_it_works_detail03') }}</p>
        </div>
      </div>
    </section>

    <hr>

    <!-- Section Mobile App -->
    <section class="section-mobile section-padding">
      <div class="row">
        <div class="col-md-7">
          <h2>{{ $t('message.home.mobile_title') }}</h2>
          <div class="mobile-feature">
            <div><i class="far fa-paper-plane text-primary"></i></div>
            <p>
            <h3>{{ $t('message.home.mobile_title01') }}</h3>
            {{ $t('message.home.mobile_detail01') }}
            </p>
          </div>
          <div class="mobile-feature">
            <div><i class="far fa-bell text-primary"></i></div>
            <p>
            <h3>{{ $t('message.home.mobile_title02') }}</h3>
            {{ $t('message.home.mobile_detail02') }}
            </p>
          </div>
          <div class="mobile-feature">
            <div><i class="far fa-comment-dots text-primary"></i></div>
            <p>
            <h3>{{ $t('message.home.mobile_title03') }}</h3>
            {{ $t('message.home.mobile_detail03') }}
            </p>
          </div>
          <div class="mobile-app-download">
            <a href="https://itunes.apple.com/th/app/beneat/id1203611695?mt=8" target="_blank">
              <img src="/static/img/btn-app-store.svg" class="img-app-download">
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://play.google.com/store/apps/details?id=com.beneat.app" target="_blank">
              <img src="/static/img/btn-play-store.svg" class="img-app-download">
            </a>
          </div>
        </div>
        <div class="col-md-5 d-none d-md-block text-center">
          <img src="/static/img/beneat-app.png" height="420">
        </div>
      </div>
    </section>


    <!-- Section Media -->
    <section-partner />

    <!-- Section Apply Cleaner -->
    <section class="section-apply-cleaner section-padding-gray">
      <div class="row">
        <div class="col-md-6">
          <div class="apply-professionals-content">
            <h2>{{ $t('message.apply.title') }}</h2>
            <p>{{ $t('message.apply.sub_title') }}</p>
            <p>{{ $t('message.apply.supported_by') }}</p>
            <div class="my-3">
              <img src="/static/img/business-customer14.png" width="360">
            </div>
            <router-link to="/apply" tag="button" class="button button-large -yellow mt-2">
              {{ $t('message.button.apply_cleaner') }}
            </router-link>
          </div>
        </div>
        <div class="col-md-6">
          &nbsp;
        </div>
      </div>
    </section>

  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import recommendProfessionals from './home/RecommendProfessionals'
  import reviewByUser from './review/ReviewByUser'
  import PromotionSlider from './promotion/Slider'
  import UserCoinsPoints from './home/UserCoinsPoints'
  import userEventLogHelpers from '../helpers/userEventLogHelpers'
  import insiderHelpers from '../helpers/insiderHelpers'
  import SectionPartner from './SectionPartner'

  export default {
    components: {
      PromotionSlider,
      recommendProfessionals,
      reviewByUser,
      UserCoinsPoints,
      SectionPartner
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        hasCompletedOrders: 'user/getHasCompletedOrders',
        newInbox: 'notification/getNewInbox',
        state: 'auth/getState',
        user: 'auth/getUser'
      }),
      ...mapState({
        reviewsByUser: state => state.review.reviewByUsers
      }),
      sortedServices () {
        return this._.orderBy(this.globalState.services, ['position'], ['asc'])
      }
    },
    watch: {
      user (newVal, oldVal) {
        if (newVal) {
          this.fetchCompletedOrders()
          // Insider homepage view event
          insiderHelpers.homePageViewEvent(newVal)
        }
      },
      hasCompletedOrders () {
        if (this.hasCompletedOrders) {
          window.localStorage.setItem('hasCompletedOrders', 'true')
        }
      }
    },
    methods: {
      getServiceUrl (service) {
        let url = service.route_url
        if (url === '/service-requests/booking') {
          url = url + `?service_id=${service.id}`
        }
        return url
      },
      fetchNotifications () {
        this.$store.dispatch('notification/LOAD_NOTIFICATIONS', this.user.id)
      },
      fetchCompletedOrders () {
        if (this.user) {
          if (window.localStorage.getItem('hasCompletedOrders') === 'true') {
            this.$store.commit('user/SET_HAS_COMPLETED_ORDERS', true)
          } else {
            this.$store.dispatch('user/HAS_COMPLETED_ORDERS', this.user.id)
          }
        }
      },
      openLoginModal () {
        this.$store.commit('auth/SET_LOGIN_FORM_TYPE', 'login')
        this.$parent.openModal('login')
      }
    },
    async mounted () {
      if (this.user) {
        // Save user event log
        userEventLogHelpers.logEvent('enter_homepage', null)

        this.fetchNotifications()
        this.fetchCompletedOrders()
      }
      // Insider homepage view event
      insiderHelpers.homePageViewEvent(this.user)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue